import loadable from '@loadable/component';

import LoadingPage from '../../components/LoadingPage';

const LoadableAppealsPage = loadable(() => import('./index'), {
  fallback: LoadingPage,
});

export default LoadableAppealsPage;
